import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function StockOutHistory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    api.get("/transfers")
      .then((r) => {
        if (active) setRows(Array.isArray(r.data) ? r.data : []);
      })
      .catch((e) => {
        if (active) setError(e.response?.data?.detail || "Gagal memuat riwayat.");
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return (
    <div className="space-y-3 rounded-lg border bg-white p-5">
      <h2 className="text-lg font-semibold">Riwayat Transfer Stok</h2>
      {loading && <p className="text-sm text-slate-500">Memuat data...</p>}
      {error && <p className="text-sm text-red-600">{error}</p>}
      {!loading && !error && rows.length === 0 && (
        <p className="text-sm text-slate-500">Belum ada data transfer.</p>
      )}
      {rows.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[650px] text-sm">
            <thead><tr className="border-b text-left">
              <th className="p-2">Nomor</th><th className="p-2">Tanggal</th>
              <th className="p-2">Dari</th><th className="p-2">Tujuan</th>
              <th className="p-2">Barang</th><th className="p-2">Status</th>
            </tr></thead>
            <tbody>{rows.map((x) => (
              <tr key={x.id} className="border-b">
                <td className="p-2">{x.transfer_no || x.id}</td>
                <td className="p-2">{String(x.created_at || "").slice(0, 10) || "-"}</td>
                <td className="p-2">{x.source_name || x.source_id || "-"}</td>
                <td className="p-2">{x.dest_name || x.dest_id || "-"}</td>
                <td className="p-2">{(x.items || []).length}</td>
                <td className="p-2">{x.status || "-"}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
